import AdminListPage from "./components/AdminListPage";
export default function InboisList() { return <AdminListPage title="Senarai Inbois" endpoint="/admin/inbois" />; }
